import React, { useState, useEffect, useReducer } from 'react'
import {
  Panel,
  Message,
  Row,
  Col,
  ControlLabel,
  Input,
  RadioGroup,
  Radio,
  SelectPicker,
  Uploader,
  Icon,
  InputGroup,
  DatePicker,
  Table,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import {
  getMaxLengthData,
  isImageOrPdf,
  isValidators,
  requiredFiled,
} from '../../utils/ValidatorUtils'
import { isEmpty } from 'lodash-es'
import { DATE_FORMAT, DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'

import InputForm from '../../components/forms/input/InputForm'

import { getReceivedFrom } from '../../redux/actions/incomeAndExpense'
import { sessionGetItemJSON, sessionGetItemStr } from '../../utils/sessionHelpers'
import notification from '../../utils/notification'
import moment from 'moment'

import { DD_MM_YYYY_SLASH } from '../../constants/date'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { startLoading, doneLoading } from '../../utils/loading'
import { getBorrowAdvanceAttachments } from '../../redux/actions/paymentRecordAdvance'
import PayeeModalWidget from '../payee/PayeeModalWidget'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function PaymentRecordAdvanceForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  setIsEnableEdit = () => {},
  projectStartDate,
  projectEndDate,
  objectDisabled,
  ...props
}) {
  // const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)
  const [accChannel, setAccChannel] = useState(_schema.accountChannel.value || '1')
  const [receiveMoneyEtcVal, setReceiveMoneyEtcVal] = useState(_schema.receiveMoneyEtc.value || '')
  const [fileTypeError, setFileTypeError] = useState(false)
  const [period, setPeriod] = useState()
  const [totalPeriod, setTotalPeriod] = useState()
  const [showReceiveMoneyEtc, setShowReceiveMoneyEtc] = useState(false)
  // const [receivedFromSchema, setReceivedFromSchema] = useState()
  // const [searchNameOrId, setSearchNameOrId] = useState()
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)

  const [fileTableData, setFileTableData] = useState([])
  const [isShowMsgVoucherDate, setIsShowMsgVoucherDate] = useState(false)
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const projectCode = sessionGetItemStr('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')

  const defaultMaxFileSize = 5

  const [borrowDate, setBorrowDate] = useState(
    formSchema?.borrowedDate?.value
      ? moment(formSchema.borrowedDate.value, DD_MM_YYYY_SLASH).toDate()
      : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
        ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
        : new Date()
  )

  const [voucherDate, setVoucherDateVal] = useState(
    formSchema?.voucherDate?.value
      ? moment(formSchema.voucherDate.value, DD_MM_YYYY_SLASH).toDate()
      : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
        ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
        : new Date()
  )

  useEffect(() => {
    const periods = _schema?.periodOption?.options?.map((object) => {
      return object.value
    })

    if (periods) {
      setTotalPeriod(Math.max(...periods))
    }

    setPeriod(_schema?.periodOption?.value)
  }, [_schema])

  useEffect(() => {
    register('deleteFileIds', [])
    setFileTableData(formSchema?.attachFiles?.values)
  }, [formSchema])

  const handleSelectVender = (dataRow) => {
    setReceiveMoneyEtcVal(dataRow?.name)
    setValue(formSchema?.receiveMoneyEtc?.name, dataRow?.id)
    clearErrors(formSchema?.receiveMoneyEtc?.name)
    setShowReceiveMoneyEtc(false)
  }

  // const handleCallReceivedFrom = async (nameOrId) => {
  //   const response = await getReceivedFromsValue(nameOrId)
  //   // console.log(response)
  //   if (response) {
  //     setReceivedFromSchema(response)
  //     setShowReceiveMoneyEtc(true)
  //     // setTimeout(() => {
  //     //   forceUpdate()
  //     // }, 500)
  //   }
  // }

  const getReceivedFromsValue = async (nameOrId) => {
    try {
      let response = await getReceivedFrom(projectCode, nameOrId)

      if (response) {
        return response
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
        })
        return null
      }
    } catch (e) {
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errorMessage || DEFAULT_ERR_MSG,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
        })
      }
    }
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getBorrowAdvanceAttachments(fileObj.id)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getBorrowAdvanceAttachments(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDeleteFileTable = (rowData) => {
    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)
    setValue('deleteFileIds', arr)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  const handleConFirmVoucherDate = () => {
    console.log('Confirm voucher date')

    const value = getValues(formSchema.borrowedDate.name)

    // console.log('value ', value)

    // setValue(formSchema.voucherDate.name, null)

    // setValue(formSchema.borrowedDate.name, borrowDate)

    setIsShowMsgVoucherDate(false)
    // setVoucherDateVal(null)
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={
          periodInfo && (
            <div style={{ textAlign: 'left' }}>
              <Col lg={12} md={12} sm={24} xs={24}>
                {formSchema.header || (
                  <span>{periodInfo?.periodNo + ' (' + periodInfo?.startAndEndDate + ')'}</span>
                )}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <span>
                  {'งวดที่ ' + periodInfo?.periodNumber + '/' + periodInfo?.periodOfLength}
                </span>
              </Col>
            </div>
          )
        }
      >
        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherNumber.validators, formSchema.voucherNumber.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {formSchema.voucherNumber.value ? (
              <b>{formSchema.voucherNumber.value}</b>
            ) : (
              <>
                <ErrorMessage error={errors[formSchema.voucherNumber.name]} />
                <Input
                  name={formSchema.voucherNumber.name}
                  defaultValue={formSchema.voucherNumber.value}
                  inputRef={register(isValidators(formSchema.voucherNumber.validators))}
                  placeholder={
                    formSchema.voucherNumber.hint
                      ? formSchema.voucherNumber.hint.toUpperCase()
                      : formSchema.voucherNumber.label
                  }
                  disabled={formSchema.voucherNumber.disabled}
                />
              </>
            )}
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.accountChannel.validators, formSchema.accountChannel.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.accountChannel.name]} />
            <Controller
              name={formSchema.accountChannel.name}
              control={control}
              defaultValue={formSchema.accountChannel.value || '1'}
              rule={register(isValidators(formSchema.accountChannel.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    inline
                    value={props.value}
                    onChange={(value) => {
                      // console.log('value ', value)
                      props.onChange(value)
                      setAccChannel(value)
                    }}
                  >
                    {formSchema.accountChannel.options.map((item) => (
                      <Radio
                        key={item.value}
                        value={item.value}
                        disabled={formSchema.accountChannel.disabled}
                      >
                        {item.label}
                      </Radio>
                    ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.referenceNumber.validators,
                formSchema.referenceNumber.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.referenceNumber.name]} />
            <Input
              name={formSchema.referenceNumber.name}
              defaultValue={formSchema.referenceNumber.value}
              inputRef={register(isValidators(formSchema.referenceNumber.validators))}
              placeholder={'ระบุ' + formSchema.referenceNumber.label}
              disabled={formSchema.referenceNumber.disabled}
            />
          </Col>
        </Row>

        {accChannel == 2 && (
          <>
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(formSchema.bankAccount.validators, formSchema.bankAccount.label)}
                </ControlLabel>
              </Col>
              <Col lg={20} md={20} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.bankAccount.name]} />
                <Controller
                  name={formSchema.bankAccount.name}
                  control={control}
                  defaultValue={formSchema.bankAccount.value}
                  rules={isValidators(formSchema.bankAccount.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        style={{ minWidth: '40%' }}
                        virtualized={false}
                        searchable={true}
                        data={formSchema.bankAccount.options}
                        value={props.value}
                        menuAutoWidth
                        placeholder={`เลือก ${formSchema.bankAccount.label}`}
                        disabled={formSchema.bankAccount.disabled}
                        onChange={(value) => {
                          props.onChange(value)
                          // setAccChannel(value)
                          // setIsEnableEdit(value != confirmAccChannel)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        {accChannel == 3 && (
          <>
            <Row>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkDocNumber.validators,
                    `${formSchema.checkDocNumber.label}`
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkDocNumber.name]} />
                <Controller
                  name={formSchema.checkDocNumber.name}
                  control={control}
                  defaultValue={formSchema.checkDocNumber.value || ''}
                  rules={isValidators(formSchema.checkDocNumber.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={'ระบุ' + formSchema.checkDocNumber.label}
                        value={props.value}
                        type="number"
                        maxLength={getMaxLengthData(formSchema.checkDocNumber.validators).value}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                        disabled={formSchema.checkDocNumber.disabled}
                        style={{ minWidth: '40%' }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkDocDate.validators,
                    `${formSchema.checkDocDate.label}`
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkDocDate.name]} />
                <Controller
                  key={formSchema.checkDocDate.name}
                  name={formSchema.checkDocDate.name}
                  control={control}
                  defaultValue={
                    formSchema.checkDocDate.value
                      ? moment(
                          moment(formSchema.checkDocDate.value).format(DATE_PICKER_FORMAT),
                          DATE_PICKER_FORMAT
                        ).toDate()
                      : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                        ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                        : new Date()
                  }
                  rules={isValidators(formSchema.checkDocDate.validators)}
                  render={(props) => {
                    return (
                      <DatePickerCustom
                        {...props}
                        startDate={periodInfo?.periodDateStart}
                        endDate={periodInfo?.periodDateEnd}
                      />
                      // <DatePicker
                      //   format={DATE_PICKER_FORMAT}
                      //   locale={LOCAL_DAY_TH}
                      //   block
                      //   oneTap
                      //   value={props.value}
                      //   onChange={(value) => {
                      //     props.onChange(value)
                      //     // onChangeReportDate(value)
                      //   }}
                      // />
                    )
                  }}
                />
              </Col>
            </Row>
            <Row style={{ marginTop: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ControlLabel>
                  {requiredFiled(
                    formSchema.checkBankInput.validators,
                    formSchema.checkBankInput.label
                  )}
                </ControlLabel>
              </Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <ErrorMessage error={errors[formSchema.checkBankInput.name]} />
                <Controller
                  name={formSchema.checkBankInput.name}
                  control={control}
                  defaultValue={formSchema.checkBankInput.value}
                  rules={isValidators(formSchema.checkBankInput.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        // style={{ minWidth: '40%' }}
                        style={{ width: '100%' }}
                        virtualized={false}
                        searchable={true}
                        data={formSchema.checkBankInput.options}
                        value={props.value}
                        menuAutoWidth
                        placeholder={`เลือก ${formSchema.checkBankInput.label}`}
                        disabled={formSchema.checkBankInput.disabled}
                        onChange={(value) => {
                          props.onChange(value)
                          // setAccChannel(value)
                          // setIsEnableEdit(value != confirmAccChannel)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
          </>
        )}

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.receiveMoneyEtc.validators,
                formSchema.receiveMoneyEtc.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.receiveMoneyEtc.name]} />
            <Controller
              name={formSchema.receiveMoneyEtc.name}
              control={control}
              defaultValue={formSchema.receiveMoneyEtc.valueDef}
              rules={isValidators(formSchema.receiveMoneyEtc.validators)}
              render={(props) => {
                return (
                  <InputGroup>
                    <Input
                      disabled
                      value={receiveMoneyEtcVal}
                      placeholder={'ระบุ' + formSchema.receiveMoneyEtc.label}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                      style={{ backgroundColor: 'transparent' }}
                    />
                    {!objectDisabled && (
                      <InputGroup.Button
                        style={{ color: '#fff', backgroundColor: '#2ba888' }}
                        onClick={() => {
                          setShowReceiveMoneyEtc(true)
                          // handleCallReceivedFrom(null)
                          // setSearchNameOrId('')
                        }}
                      >
                        <Icon icon="ellipsis-h" size="lg" />
                      </InputGroup.Button>
                    )}
                  </InputGroup>
                )
              }}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.voucherDate.validators, formSchema.voucherDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.voucherDate.name]} />
            {/* วันที่เอกสาร */}

            <Controller
              key={formSchema.voucherDate.name}
              name={formSchema.voucherDate.name}
              control={control}
              defaultValue={
                formSchema.voucherDate.value
                  ? moment(formSchema.voucherDate.value, DD_MM_YYYY_SLASH).toDate()
                  : new Date() > moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                    ? moment(periodInfo?.periodDateEnd, DATE_FORMAT).toDate()
                    : new Date()
              }
              rules={isValidators(formSchema.voucherDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    disabled={formSchema.voucherDate.disabled}
                    onChange={(value) => {
                      props.onChange(value)
                      setValue(formSchema.borrowedDate.name, value)
                      setVoucherDateVal(value)
                      setBorrowDate(value)
                    }}
                    startDate={periodInfo?.periodDateStart}
                    endDate={moment.min(
                      moment(
                        startDate ? moment(startDate).add(-1, 'days') : periodInfo?.periodDateEnd
                      ),
                      moment(new Date())
                    )}
                    // startDate={sessionGetItemStr('projectStartDate')}
                    // endDate={sessionGetItemStr('projectEndDate')}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          {/* <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.expenseType.validators, formSchema.expenseType.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.expenseType.name]} />
            <Input
              name={formSchema.expenseType.name}
              defaultValue={formSchema.expenseType.value}
              inputRef={register(isValidators(formSchema.expenseType.validators))}
              placeholder={'ระบุ' + formSchema.expenseType.label}
              // disabled
              disabled={formSchema.expenseType.disabled}
            />
          </Col> */}

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.startDateActive.validators,
                formSchema.startDateActive.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.startDateActive.name]} />
            {/* วันเริ่มต้นกิจกรรม */}

            <Controller
              key={formSchema.startDateActive.name}
              name={formSchema.startDateActive.name}
              control={control}
              defaultValue={
                formSchema.startDateActive.value
                  ? moment(formSchema.startDateActive.value, DD_MM_YYYY_SLASH).toDate()
                  : null
              }
              rules={isValidators(formSchema.startDateActive.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    disabled={formSchema.startDateActive.disabled}
                    startDate={
                      borrowDate
                        ? borrowDate
                        : voucherDate
                          ? voucherDate
                          : periodInfo?.periodDateStart
                    }
                    //endDate={endDate || periodInfo?.periodDateEnd}
                    // startDate={sessionGetItemStr('projectStartDate')}
                    endDate={endDate || sessionGetItemStr('projectEndDate')}
                    //value={startDate}
                    onChange={(value) => {
                      props.onChange(value)
                      setStartDate(value)
                    }}
                  />
                )
              }}
            />
          </Col>

          {/* </Row>

        <Row style={{ marginTop: 10 }}> */}
          {/* <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.residence.validators, formSchema.residence.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.residence.name]} />
            <Input
              name={formSchema.residence.name}
              defaultValue={formSchema.residence.value}
              inputRef={register(isValidators(formSchema.residence.validators))}
              placeholder={'ระบุ' + formSchema.residence.label}
              disabled={formSchema.residence.disabled}
            />
          </Col> */}

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.stopDateActive.validators, formSchema.stopDateActive.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.stopDateActive.name]} />
            {/* วันสิ้นสุดกิจกรรม */}
            <Controller
              key={formSchema.stopDateActive.name}
              name={formSchema.stopDateActive.name}
              control={control}
              defaultValue={
                formSchema.stopDateActive.value
                  ? moment(formSchema.stopDateActive.value, DD_MM_YYYY_SLASH).toDate()
                  : null
              }
              rules={isValidators(formSchema.stopDateActive.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    disabled={formSchema.stopDateActive.disabled}
                    startDate={
                      startDate
                        ? startDate
                        : borrowDate
                          ? borrowDate
                          : voucherDate
                            ? voucherDate
                            : periodInfo?.periodDateStart
                    }
                    endDate={sessionGetItemStr('projectEndDate')}
                    onChange={(value) => {
                      props.onChange(value)
                      setEndDate(value)
                      if (value) {
                        setValue(
                          formSchema.dueDate.name,
                          moment(value, DD_MM_YYYY_SLASH).add(15, 'days').toDate()
                        )
                      } else {
                        setValue(formSchema.dueDate.name, null)
                      }
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.borrowedDate.validators, formSchema.borrowedDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.borrowedDate.name]} />
            {/* วันที่ยืม */}
            <Controller
              key={formSchema.borrowedDate.name}
              name={formSchema.borrowedDate.name}
              control={control}
              defaultValue={borrowDate}
              rules={isValidators(formSchema.borrowedDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    disabled={formSchema.borrowedDate.disabled}
                    startDate={voucherDate ? voucherDate : periodInfo?.periodDateStart}
                    endDate={
                      startDate
                        ? moment(startDate).add(-1, 'days')
                        : sessionGetItemStr('projectEndDate')
                    }
                    onChange={(value) => {
                      setBorrowDate(value)

                      // if (moment(value).isBefore(moment(voucherDate))) {
                      //   setIsShowMsgVoucherDate(true)
                      // } else {
                      props.onChange(value)
                      // }

                      // if (startDate < value) {
                      //   setStartDate(undefined)
                      // }
                    }}
                  />
                )
              }}
            />
          </Col>

          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.dueDate.validators, formSchema.dueDate.label)}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.dueDate.name]} />
            {/* วันที่ครบกำหนด */}
            <Controller
              key={formSchema.dueDate.name}
              name={formSchema.dueDate.name}
              control={control}
              defaultValue={
                formSchema.dueDate.value
                  ? moment(formSchema.dueDate.value, DD_MM_YYYY_SLASH).toDate()
                  : null
              }
              rules={isValidators(formSchema.dueDate.validators)}
              render={(props) => {
                return (
                  <DatePickerCustom
                    {...props}
                    disabled={true}
                    // disabled={!endDate && !formSchema.dueDate.value}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.description.validators, formSchema.description.label)}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {/* <ErrorMessage error={errors[formSchema.description.name]} /> */}
            <InputForm
              hideLabel
              schema={formSchema.description}
              rows={4}
              componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.attachFiles.validators, formSchema.attachFiles.label)}
            </ControlLabel>
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {/* <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${
                formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
              }`}
              style={{ marginBottom: 10 }}
            /> */}
            <ErrorMessage error={errors[formSchema.attachFiles.name]} />
            <Controller
              key={formSchema.attachFiles.name}
              name={formSchema.attachFiles.name}
              control={control}
              rules={isValidators(fileTableData.length == 0 && formSchema.attachFiles.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <Uploader
                    accept={formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                    autoUpload={false}
                    disabled={formSchema.attachFiles.disabled}
                    fileListVisible={true}
                    listType="picture-text"
                    fileList={props.value || []}
                    onChange={(fileList) => {
                      if (isEmpty(fileList)) {
                        props.onChange(undefined)
                      } else {
                        let file = fileList[fileList.length - 1]

                        if (
                          file.blobFile.size >
                          (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024
                        ) {
                          notification.open('error', {
                            title: `ขนาดไฟล์เกิน ${
                              formSchema.attachFiles.fileSize || defaultMaxFileSize
                            } MB`,
                            duration: 5000,
                          })
                          return
                        }

                        if (isImageOrPdf(file.blobFile.type)) {
                          props.onChange(fileList)
                          setFileTypeError(false)
                        } else {
                          setFileTypeError(true)
                          notification.open('error', {
                            title:
                              'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                              '.jpg, .jpeg, .png, .pdf',
                            duration: 5000,
                          })
                        }
                      }
                    }}
                    draggable
                  >
                    <div>
                      <Icon size="2x" icon="upload2" />
                      <small className="uploder__text"></small>
                      {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                        formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                      } , ขนาดไฟล์ไม่เกิน ${
                        formSchema.attachFiles.fileSize || defaultMaxFileSize
                      } MB`}
                    </div>
                    {/* <div style={{ lineHeight: '100px' }}>
                      <Icon size="4x" icon="upload2" />
                      <small
                        style={{
                          marginTop: '-70px',
                          display: 'block',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                      </small>
                    </div> */}
                  </Uploader>
                )
              }}
            />

            {fileTableData?.length > 0 && (
              <>
                <br />
                <IncomeRecordFileTable
                  data={fileTableData}
                  deleteable={true}
                  onPreview={onPreview}
                  onDownload={onDownload}
                  onDelete={(rowData) => handleDeleteFileTable(rowData)}
                />
              </>
            )}
          </Col>
        </Row>
      </Panel>

      {showReceiveMoneyEtc && (
        <PayeeModalWidget
          title={'ค้นหารายการ ผู้ยืมเงินทดรองจ่าย'}
          projectCode={projectCode}
          isViewMode={false}
          show={showReceiveMoneyEtc}
          onSelect={handleSelectVender}
          onClose={() => setShowReceiveMoneyEtc(false)}
        />
      )}

      <ConfirmWidget
        // title={`${formSchema.borrowedDate.label} น้อยกว่า ${formSchema.voucherDate.label}`}
        title={''}
        show={isShowMsgVoucherDate}
        detail={
          <div
            dangerouslySetInnerHTML={{
              __html: `${formSchema.borrowedDate.label} <u><b>${borrowDate ? moment(new Date(borrowDate)).format(DD_MM_YYYY_SLASH) : ''}</b></u> น้อยกว่า ${formSchema.voucherDate.label} <u><b>${voucherDate ? moment(new Date(voucherDate)).format(DD_MM_YYYY_SLASH) : ''}</b></u> กรุณาเลือกวันที่เอกสารใหม่`,
            }}
          />
        }
        onConfirm={handleConFirmVoucherDate}
        hideCancle={true}
        size="lg"
        confirmBtn={'ปิด'}
      />

      {/* <div className="modal-container"> */}
      {/* <Modal full show={showReceiveMoneyEtc} onHide={() => setShowReceiveMoneyEtc(false)}>
        <Modal.Header>
          <Modal.Title>
            <div style={{ padding: 10 }}>ผู้ยืมเงินทดรองจ่าย</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ width: '99%' }}>
            <Row>
              <Col lg={12} md={12} sm={24} xs={24} style={{ width: '60%' }}>
                <InputGroup style={{ width: '100%' }}>
                  <Input
                    defaultValue={searchNameOrId}
                    value={searchNameOrId}
                    placeholder={'ระบุชื่อ หรือ เลขที่ผู้เสียภาษี'}
                    onChange={(value) => setSearchNameOrId(value)}
                  />

                  <InputGroup.Button
                    style={{ color: '#fff', backgroundColor: '#2ba888' }}
                    onClick={() => handleCallReceivedFrom(searchNameOrId)}
                  >
                    <Icon icon="search" size="lg" /> ค้นหา
                  </InputGroup.Button>
                </InputGroup>
              </Col>
              <Col lg={12} md={12} sm={24} xs={24} style={{ width: '40%' }}>
                <CancelButton
                  onClick={() => {
                    handleCallReceivedFrom(null)
                    setSearchNameOrId('')
                  }}
                >
                  ยกเลิก
                </CancelButton>
              </Col>
            </Row>
            <div style={{ minHeight: 300, maxHeight: '70hv' }}>
              <List hover style={{ padding: 10 }}>
                <List.Item key={'header_'} index={-1} style={{ backgroundColor: '#F2F1F1' }}>
                  <FlexboxGrid style={{ fontWeight: 550 }}>
                    <FlexboxGrid.Item colspan={1} style={styleCenter}>
                      ลำดับ
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item colspan={4}>
                      <div>เลขที่ผู้เสียภาษี</div>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={6}>
                      <div>ชื่อ</div>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={11}>
                      <div>ที่อยู่</div>
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item colspan={2} style={styleCenter}>
                      เลือก
                    </FlexboxGrid.Item>
                  </FlexboxGrid>
                </List.Item>

                {receivedFromSchema?.values?.map((item, index) => (
                  <List.Item key={item['title']} index={index}>
                    <FlexboxGrid>
                      <FlexboxGrid.Item colspan={1} style={styleCenter}>
                        {index + 1}
                      </FlexboxGrid.Item>

                      <FlexboxGrid.Item colspan={4}>
                        <div>{item['taxId']}</div>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item colspan={6}>
                        <div>{item['name']}</div>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item colspan={11}>
                        <div>{item['address']}</div>
                      </FlexboxGrid.Item>
                      <FlexboxGrid.Item colspan={2} style={styleCenter}>
                        <Button
                          appearance="primary"
                          size="xs"
                          onClick={() => {
                            handleSelectVender(item)
                          }}
                        >
                          เลือก
                        </Button>
                      </FlexboxGrid.Item>
                    </FlexboxGrid>
                  </List.Item>
                ))}
              </List>
            </div> */}

      {/* <Table
            //height={450}
            autoHeight
            data={receivedFromSchema?.values || []}
            wordWrap
            style={{ marginTop: 10 }}
          >
            <Column width={90} align="center" fixed>
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(rowData, index) => {
                  if (rowData.isRowTotal) {
                    return ''
                  }
                  return <span>{index + 1}</span>
                }}
              </Cell>
            </Column>
            <Column width={150} align="center" fixed>
              <HeaderCell>เลขที่ผู้เสียภาษี</HeaderCell>
              <Cell dataKey="taxId" />
            </Column>

            <Column width={250}>
              <HeaderCell>ชื่อ</HeaderCell>
              <Cell dataKey="name" />
            </Column>

            <Column minWidth={250} flexGrow={1}>
              <HeaderCell>ที่อยู่</HeaderCell>
              <Cell dataKey="address" />
            </Column>

            <Column width={80}>
              <HeaderCell>เลือก</HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <>
                      <Button
                        appearance="primary"
                        size="xs"
                        onClick={() => {
                          handleSelectVender(rowData)
                        }}
                      >
                        เลือก
                      </Button>
                    </>
                  )
                }}
              </Cell>
            </Column>
          </Table> */}
      {/* </div>
         </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowReceiveMoneyEtc(false)} appearance="subtle">
            ปิด
          </Button>
        </Modal.Footer>
      </Modal> */}
      {/* </div> */}
    </>
  )
}

const styleCenter = {
  textAlign: 'center',
}

const styleHeader = {
  fontWeight: 550,
  textAlign: 'center',
}

const styleMargin = {
  marginLeft: 20,
  marginRight: 20,
}
